import { useEffect } from 'react';

const useAmexHashFragment = (offset = 0, isMobile, sectioName, hash, linkClicked) => {
  useEffect(() => {
    const scrollToHashElement = () => {
      const elementToScroll = document.getElementById(hash);
      if (!elementToScroll || isMobile === undefined || sectioName !== hash) return;

      setTimeout(() => {
        window.scrollTo({
          top: elementToScroll.offsetTop - offset,
          behavior: 'smooth',
        });
      }, 1000);
    };

    if (!hash) return;

    if (!linkClicked) scrollToHashElement();
  }, [hash, linkClicked]);
};

export default useAmexHashFragment;
